export default "__VITE_ASSET__Z3Xm4xt___"